import { makeStyles } from '@mui/styles';

import Colors from 'configs/Colors';

const useStyles = makeStyles(() => ({
  wrapper: {
    flex: 1,
    background: Colors.Grey1,
    padding: '24px 0',
  },
}));

export default useStyles;
